<template>
  <div
    class="editor_container"
    @keydown.capture="keyboardCommandsHandler"
  >
    <div class="editor_header">
      <span>Employee Name (date)</span>
    </div>
    <div class="editor_fields">
      <form class="editor_form">
        <div class="editor_field">
          <label
            for="docpicker"
            class="form_label"
          >
            Attendance Type:
          </label>
          <div class="form_docpicker">
            <v-select
              ref="inputText1"
              v-model="selected_att_type"
              style="text-overflow: ellipsis;"
              label="name"
              :disabled="isReadOnly"
              :placeholder="default_att_type"
              :options="docpOptions.att_type"
              clear-search-on-select
              :map-keydown="createKeydownHandler(0)"
              :selected="onClose(event)"
              @update:model-value="(value) => onEditFieldChange('att_type', value)"
            >
              <template #option="option">
                <div
                  @mouseover="setHovered(option)"
                >
                  <span
                    :class="{'selected_option':selected_att_type && (selected_att_type === option.name)}"
                  >
                    {{ option.name }}
                  </span>
                </div>
              </template>
            </v-select>
          </div>
        </div>
        <div
          v-if="isReadOnly"
          class="editor_field"
        >
          <label
            for="docpicker"
            class="form_label"
          >
            Leave Type:
          </label>
          <div class="form_docpicker">
            <v-select
              v-model="default_leave_type"
              style="text-overflow: ellipsis;"
              label="name"
              :disabled="isReadOnly"
              :placeholder="default_leave_type"
              :options="[]"
            />
          </div>
        </div>
        <div class="editor_field">
          <label
            for="docpicker"
            class="form_label"
          >
            Site:
          </label>
          <div class="form_docpicker">
            <v-select
              ref="inputText2"
              v-model="selected_site"
              :disabled="isReadOnly"
              label="name"
              :placeholder="default_site"
              :options="docpOptions.sites_id"
              clear-search-on-select
              :map-keydown="createKeydownHandler(1)"
              @update:model-value="(value) => onEditFieldChange('sites_id', value)"
            >
              <template #option="option">
                <div
                  @mouseover="setHovered(option)"
                >
                  <span
                    :class="{'selected_option':selected_site && (selected_site === option.name)}"
                  >
                    {{ option.name }}
                  </span>
                </div>
              </template>
            </v-select>
          </div>
        </div>
        <div class="editor_field">
          <label
            for="docpicker"
            class="form_label"
          >
            Shift:
          </label>
          <div class="form_docpicker">
            <v-select
              ref="inputText3"
              v-model="selected_shift"
              :disabled="isReadOnly"
              label="name"
              :placeholder="default_shift"
              :options="docpOptions.shifts_id"
              clear-search-on-select
              :map-keydown="createKeydownHandler(2)"
              @update:model-value="(value) => onEditFieldChange('shifts_id', value)"
            >
              <template #option="option">
                <div
                  @mouseover="setHovered(option)"
                >
                  <span
                    :class="{'selected_option':selected_shift && (selected_shift === option.name)}"
                  >
                    {{ option.name }}
                  </span>
                </div>
              </template>
            </v-select>
          </div>
        </div>
        <div class="editor_field">
          <label
            for="docpicker"
            class="form_label"
          >
            Designation:
          </label>
          <div class="form_docpicker">
            <v-select
              ref="inputText4"
              v-model="selected_designation"
              :disabled="isReadOnly"
              label="name"
              :placeholder="default_designation"
              :options="docpOptions.designation"
              clear-search-on-select
              :map-keydown="createKeydownHandler(3)"
              @update:model-value="(value) => onEditFieldChange('designation', value)"
            >
              <template #option="option">
                <div
                  @mouseover="setHovered(option)"
                >
                  <span
                    :class="{'selected_option':selected_designation && (selected_designation === option.name)}"
                  >
                    {{ option.name }}
                  </span>
                </div>
              </template>
            </v-select>
          </div>
        </div>
        <div class="editor_field">
          <label
            for="docpicker"
            class="form_label"
          >
            Department:
          </label>
          <div class="form_docpicker">
            <v-select
              ref="inputText5"
              v-model="selected_department"
              :disabled="isReadOnly"
              label="name"
              :placeholder="default_department"
              :options="docpOptions.departments"
              clear-search-on-select
              :map-keydown="createKeydownHandler(4)"
              @update:model-value="(value) => { onDepartmentChange(); onEditFieldChange('departments', value); }"
            >
              <template #option="option">
                <div
                  @mouseover="setHovered(option)"
                >
                  <span
                    :class="{'selected_option':selected_department && (selected_department === option.name)}"
                  >
                    {{ option.name }}
                  </span>
                </div>
              </template>
            </v-select>
          </div>
        </div>
        <div class="editor_field">
          <label
            for="docpicker"
            class="form_label"
          >
            Subsection:
          </label>
          <div class="form_docpicker">
            <v-select
              ref="inputText6"
              v-model="selected_subsection"
              :disabled="isReadOnly"
              label="name"
              :placeholder="default_subsection"
              :options="subsOptions"
              clear-search-on-select
              :map-keydown="createKeydownHandler(5)"
              @update:model-value="(value) => onEditFieldChange('subsections', value)"
            >
              <template #option="option">
                <div
                  @mouseover="setHovered(option)"
                >
                  <span
                    :class="{'selected_option':selected_subsection && (selected_subsection === option.name)}"
                  >
                    {{ option.name }}
                  </span>
                </div>
              </template>
            </v-select>
          </div>
        </div>
        <div class="editor_field">
          <label
            for="docpicker"
            class="form_label"
          >
            Working Hours:
          </label>
          <div class="form_docpicker">
            <input
              id="inputText5"
              ref="input0"
              v-model="workingHrs"
              :disabled="isReadOnly"
              :style="error !== '' ? 'border: 1px solid red;': ''"
              type="text"
              placeholder="HH:MM"
              class="my-simple-editor form-control form-control-sm"
              maxlength="5"
              @input="handleWorkingHoursInput"
              @keydown="(event) => handleKeydown(4, event)"
            >
            <p v-if="error">
              {{ error }}
            </p>
            <p v-else-if="workingHrs">
              {{ formattedTime }}
            </p>
          </div>
        </div>
        <div class="editor_field">
          <label
            for="docpicker"
            class="form_label"
          >
            Overtime Hours:
          </label>
          <div class="form_docpicker">
            <input
              id="inputText6"
              ref="input2"
              v-model="overtimeHrs"
              :disabled="isReadOnly"
              type="text"
              placeholder="0:0"
              class="my-simple-editor form-control form-control-sm"
              tabindex="1"
              @input="handleOvertimeHoursInput"
              @keydown="(event) => handleKeydown(5, event)"
            />
          </div>
        </div>
        <div class="editor_field">
          <label
            for="docpicker"
            class="form_label"
          >
            In Time:
          </label>
          <div class="form_docpicker">
            <input
              id="inputText6"
              ref="input2"
              v-model="inTime"
              :disabled="true"
              step="2"
              type="time"
              class="my-simple-editor form-control form-control-sm"
              tabindex="1"
              @keydown="(event) => handleKeydown(5, event)"
            />
          </div>
        </div>
        <div class="editor_field">
          <label
            for="docpicker"
            class="form_label"
          >
            Out Time:
          </label>
          <div class="form_docpicker">
            <input
              id="inputText7"
              ref="input3"
              v-model="outTime"
              :disabled="true"
              step="2"
              type="time"
              class="my-simple-editor form-control form-control-sm"
              tabindex="1"
              @keydown="(event) => handleKeydown(6, event)"
            />
          </div>
        </div>
        <div class="editor_field">
          <label
            for="docpicker"
            class="form_label"
          >
            Notes{{ isNotesMandatoryForCurrentEdit() ? ' *' : '' }}:
          </label>
          <div class="form_docpicker">
            <input
              id="inputText8"
              ref="input1"
              v-model="notes"
              :disabled="isReadOnly"
              :style="noteValidationError !== '' ? 'border: 1px solid red;' : ''"
              type="text"
              placeholder="Enter remarks here"
              class="my-simple-editor form-control form-control-sm"
              tabindex="1"
              @input="onNotesInput"
              @keydown="(event) => handleKeydown(7, event)"
            />
            <p v-if="noteValidationError">
              {{ noteValidationError }}
            </p>
          </div>
        </div>
      </form>
    </div>
    <div class="editor_bottom">
      <span>Ctrl + Enter to save</span>
    </div>
  </div>
</template>
<script>
import { ref, onMounted, computed, nextTick, watch } from 'vue';
import attendanceGridUtils from '../../../composables/attendanceGridUtils';
import { toast } from 'vue3-toastify';
import { useStore } from 'vuex';
import getFolders from '../../../composables/getFolders';


export default {
  name: 'CellEditor',
  setup(props) {
    const value = ref('value' in props.params ? JSON.parse(JSON.stringify(props.params.value)) : undefined);
    const initialAttendanceSnapshot = ref(value.value != null ? JSON.parse(JSON.stringify(value.value)) : {});
    const {
      getAttendanceDate,
      convertMinutesToHoursFormat,
      timeStringToMinutes,
      getAttendanceEditNotesPolicyMode,
      isNotesRequiredByPolicy
    } = attendanceGridUtils();
    const default_leave_type = ref('');
    const isReadOnly = ref(false);
    if (value.value?.leave_type !== undefined && value.value?.leave_type !== null && value.value?.leave_type.length > 0) {
      isReadOnly.value = true;
      default_leave_type.value = value.value.leave_type?.[0]?.name?.eng;
    }
    if (value.value?.attendance_status !== undefined && value.value?.attendance_status !== null) {
      if (value.value?.attendance_status?.[0]?.code === 'final_approved') {
        isReadOnly.value = true;
      }
    }

    const store = useStore();
    let isHovered = null;
    const bSettings = store.getters['bSettings'];
    const { getAllFoldersList, getCurrentFolder } = getFolders()
    const folderList = getAllFoldersList(bSettings);
    const attendanceEditsFolder = getCurrentFolder('attendance_edits', folderList);
    const editsForm = attendanceEditsFolder.forms.attendance_edits_create_form;
    console.log('I am here', editsForm);

    const inputText1 = ref(null);
    const inputText2 = ref(null);
    const inputText3 = ref(null);
    const inputText4 = ref(null);
    const inputText5 = ref(null);
    const inputText6 = ref(null);
    const input1 = ref(null);
    const input2 = ref(null);
    const input3 = ref(null);
    const input4 = ref(null);
    const input5 = ref(null);

    let dataSource = {};
    dataSource = props.params?.cellEditorDataSource;
    const docpOptions = ref({});
    const selected_att_type = ref();
    const workingHrs = ref(null);
    const error = ref('');
    const overtimeHrs = ref(null);
    const inTime = ref(null);
    const outTime = ref(null);
    const notes = ref(null);
    const noteValidationError = ref('');
    const editFieldTouched = ref(false);
    const isInitializingEditor = ref(true);
    const initialPrefilledNote = ref(null);
    const isPrefilledNoteCleared = ref(false);
    const isNotesEditedByUser = ref(false);
    const notesPolicyMode = ref(getAttendanceEditNotesPolicyMode());
    const sanitizeEditorNote = (noteValue) => {
      if (noteValue === null || noteValue === undefined) {
        return null;
      }
      const normalized = String(noteValue).replace(/_USERREMARK_/g, '').trim();
      if (normalized.length === 0 || normalized.toLowerCase() === 'recorded attendance') {
        return null;
      }
      return normalized;
    };

    const hasMandatoryNote = () => sanitizeEditorNote(notes.value) != null;

    function resolveSelectedAttendanceType() {
      if (selected_att_type.value == null || dataSource?.att_type == null) {
        return null;
      }
      const selectedId = selected_att_type.value?.id;
      if (selectedId == null) {
        return null;
      }
      const selectedDocp = dataSource.att_type.find((item) => item.id === selectedId);
      return selectedDocp ?? null;
    }

    function buildDraftAttendanceEditForValidation() {
      const draft = {};
      const selectedAttType = resolveSelectedAttendanceType();
      if (selectedAttType != null) {
        draft.att_type = [selectedAttType];
      }
      if (Array.isArray(value.value?.leave_type) && value.value.leave_type.length > 0) {
        draft.leave_type = value.value.leave_type;
      }
      return draft;
    }

    function isNotesMandatoryForCurrentEdit() {
      const draftEdit = buildDraftAttendanceEditForValidation();
      return isNotesRequiredByPolicy(notesPolicyMode.value, initialAttendanceSnapshot.value, draftEdit);
    }

    function validateMandatoryNotes() {
      if (isReadOnly.value || !editFieldTouched.value) {
        noteValidationError.value = '';
        return true;
      }
      if (!isNotesMandatoryForCurrentEdit()) {
        noteValidationError.value = '';
        return true;
      }
      if (!hasMandatoryNote()) {
        noteValidationError.value = 'Remarks are mandatory for attendance edit.';
        return false;
      }
      noteValidationError.value = '';
      return true;
    }

    function focusNotesInput() {
      nextTick(() => {
        if (input1.value != null) {
          input1.value.focus();
        }
      });
    }

    function getFieldCurrentId(fieldName, fieldValue) {
      const normalizeFieldValue = (input) => {
        if (typeof input === 'string') {
          const trimmed = input.trim();
          if (trimmed === '' || trimmed.toLowerCase().startsWith('select ')) {
            return null;
          }
          return trimmed;
        }
        return input;
      };
      if (fieldName == null) {
        return null;
      }
      const currentValue = normalizeFieldValue(fieldValue ?? null);
      if (currentValue != null && typeof currentValue === 'object' && currentValue.id != null) {
        return currentValue.id;
      }
      if (currentValue != null && typeof currentValue === 'string') {
        return currentValue;
      }
      const fallbackMap = {
        att_type: selected_att_type.value,
        sites_id: selected_site.value,
        shifts_id: selected_shift.value,
        designation: selected_designation.value,
        departments: selected_department.value,
        subsections: selected_subsection.value,
      };
      const fallbackValue = normalizeFieldValue(fallbackMap[fieldName]);
      if (fallbackValue != null && typeof fallbackValue === 'object' && fallbackValue.id != null) {
        return fallbackValue.id;
      }
      if (fallbackValue != null && typeof fallbackValue === 'string') {
        return fallbackValue;
      }
      return null;
    }

    function getFieldOriginalIdentifiers(fieldName) {
      if (value.value == null) {
        return [];
      }
      const originalField = value.value?.[fieldName];
      if (Array.isArray(originalField) && originalField.length > 0) {
        const first = originalField[0];
        return [first?.id, first?.name?.eng, first?.name].filter((item) => item != null);
      }
      return [];
    }

    function isEffectiveFieldChange(fieldName, fieldValue) {
      if (fieldName == null) {
        return true;
      }
      if (['working_minutes', 'overtime_minutes'].includes(fieldName)) {
        const normalizeTimeValue = (timeValue) => {
          if (timeValue == null) {
            return null;
          }
          const textValue = String(timeValue).trim();
          if (textValue === '') {
            return null;
          }
          const parts = textValue.split(':');
          if (parts.length === 1) {
            const hoursOnly = Number(parts[0]);
            if (Number.isNaN(hoursOnly)) {
              return textValue.toLowerCase();
            }
            return `${String(hoursOnly).padStart(2, '0')}:00`;
          }
          const hours = Number(parts[0]);
          const minutes = Number(parts[1] === '' ? 0 : parts[1]);
          if (Number.isNaN(hours) || Number.isNaN(minutes)) {
            return textValue.toLowerCase();
          }
          return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
        };
        const currentNormalized = normalizeTimeValue(fieldValue);
        const originalValue = fieldName === 'working_minutes'
          ? convertMinutesToHoursFormat(value.value?.working_minutes)
          : convertMinutesToHoursFormat(value.value?.overtime_minutes);
        const originalNormalized = normalizeTimeValue(originalValue);
        if (currentNormalized == null && originalNormalized == null) {
          return false;
        }
        return currentNormalized !== originalNormalized;
      }
      const currentId = getFieldCurrentId(fieldName, fieldValue);
      const originalIdentifiers = getFieldOriginalIdentifiers(fieldName);
      if (currentId == null && originalIdentifiers.length === 0) {
        return false;
      }
      const currentText = String(currentId);
      return !originalIdentifiers.some((item) => String(item) === currentText);
    }

    function onEditFieldChange(fieldName = null, fieldValue = null) {
      if (isReadOnly.value) {
        return;
      }
      if (isInitializingEditor.value) {
        return;
      }
      if (!isEffectiveFieldChange(fieldName, fieldValue)) {
        return;
      }
      if (
        !isInitializingEditor.value &&
        !isPrefilledNoteCleared.value &&
        !isNotesEditedByUser.value &&
        initialPrefilledNote.value != null
      ) {
        notes.value = null;
        isPrefilledNoteCleared.value = true;
      }
      editFieldTouched.value = true;
      validateMandatoryNotes();
    }

    function onNotesInput() {
      isNotesEditedByUser.value = true;
      onEditFieldChange();
      validateMandatoryNotes();
    }

    function canSaveEditor() {
      if (error.value !== '') {
        toast.warning('Please enter valid working hours', {
          autoClose: 4000,
          closeButton: true,
          isLoading: false,
          position: toast.POSITION.TOP_CENTER,
        });
        return false;
      }
      if (!validateMandatoryNotes()) {
        toast.warning('Remarks are mandatory to mark attendance edits', {
          autoClose: 4000,
          closeButton: true,
          isLoading: false,
          position: toast.POSITION.TOP_CENTER,
        });
        focusNotesInput();
        return false;
      }
      return true;
    }
    const default_att_type = computed(() => {
      if (value.value !== undefined && value.value.hasOwnProperty('att_type')) {
        return value.value['att_type'][0]['name']['eng'];
      } else {
        return 'Select attendance';
      }
    })
    selected_att_type.value = default_att_type.value;

    const selected_designation = ref();
    const default_designation = computed(() => {
      if (value.value !== undefined && value.value.hasOwnProperty('designation') && value.value.designation != null) {
        return value.value['designation']?.[0]?.['name'];
      } else {
        return 'Select designation';
      }
    })
    selected_designation.value = default_designation.value;

    const selected_department = ref();
    const default_department = computed(() => {
      if (value.value !== undefined && value.value.departments?.[0]?.name) {
        return value.value['departments'][0];
      } else {
        return 'Select Department';
      }
    })
    selected_department.value = default_department.value;
    const selected_subsection = ref();
    const default_subsection = computed(() => {
      if (value.value !== undefined && value.value.subsections?.[0]?.name) {
        return value.value['subsections'][0];
      } else {
        return 'Select Subsection';
      }
    })
    selected_subsection.value = default_subsection.value;

    const subsOptions = computed(() => {
      return dataSource.subsections.filter((item) => item.departments.map((x) => x.id).includes(selected_department.value?.id)).map((item) => ({ name: item['name'], id: item.id }));
    })

    function onDepartmentChange() {
      if (dataSource.subsections.filter((item) => item.id == selected_subsection.value?.id && item.departments.map((x) => x.id).includes(selected_department.value?.id)).length == 0) {
        selected_subsection.value = 'Select Subsection';
        if (value.value != null) {
          value.value.subsections = [];
          if (value.value.attendance_edit != null) {
            value.value.attendance_edit.subsections = [];
          }
        }
      }
    }

    const selected_site = ref();
    const default_site = computed(() => {
      if (value.value !== undefined && value.value.hasOwnProperty('sites_id') && value.value.sites_id != null) {
        return value.value['sites_id']?.[0]?.['name']?.eng;
      } else {
        return 'Select site';
      }
    })
    selected_site.value = default_site.value;

    const selected_shift = ref();
    const default_shift = computed(() => {
      if (value.value !== undefined && value.value.hasOwnProperty('shifts_id') && value.value.shifts_id?.[0]?.name != null) {
        return value.value['shifts_id'][0]['name'];
      } else {
        return 'Select shift';
      }
    })
    selected_shift.value = default_shift.value;


    const isPopup = () => {
      return true;
    };

    function saveDepartment(attendance_edit, i) {
      if (attendance_edit.subsections == null || attendance_edit.subsections.length == 0) {
        toast.warning('Department can not be updated without selecting the subsection!', {
          autoClose: 5000,
          closeButton: true,
          isLoading: false,
          position: toast.POSITION.TOP_CENTER,
        })
      }
      else {
        value.value['departments'] = [dataSource['departments'][i]];
        attendance_edit['departments'] = [dataSource['departments'][i]];
      }
    }

    const getValue = () => {
      if (typeof value.value === 'undefined') {
        value.value = {};
      }
      if (isReadOnly.value) {
        return props.params.value;
      }
      if (!editFieldTouched.value) {
        return props.params.value;
      }
      if (editFieldTouched.value && isNotesMandatoryForCurrentEdit() && !hasMandatoryNote()) {
        validateMandatoryNotes();
        return props.params.value;
      }
      const attendance_edit = {};
      if (Object.keys(value.value) === 0) {
        if (selected_att_type.value !== undefined) {
          for (let i = 0; i < dataSource['att_type'].length; i++) {
            if (selected_att_type.value.id === dataSource['att_type'][i].id) {
              value.value['att_type'] = [dataSource['att_type'][i]];
              attendance_edit['att_type'] = [dataSource['att_type'][i]];
              break;
            }
          }
        }
        if (selected_designation.value !== undefined) {
          for (let i = 0; i < dataSource['designation'].length; i++) {
            if (selected_designation.value.id === dataSource['designation'][i].id) {
              value.value['designation'] = [dataSource['designation'][i]];
              attendance_edit['designation'] = [dataSource['designation'][i]];
              break;
            }
          }
        }
        if (selected_subsection.value != null && selected_subsection.value != 'Select Subsection') {
          for (let i = 0; i < dataSource['subsections'].length; i++) {
            if (selected_subsection.value.id === dataSource['subsections'][i].id) {
              value.value['subsections'] = [dataSource['subsections'][i]];
              attendance_edit['subsections'] = [dataSource['subsections'][i]];
              break;
            }
          }
        }
        if (selected_department.value != null) {
          for (let i = 0; i < dataSource['departments'].length; i++) {
            if (selected_department.value.id === dataSource['departments'][i].id) {
              saveDepartment(attendance_edit, i);
              break;
            }
          }
        }
        if (selected_site.value !== undefined) {
          for (let i = 0; i < dataSource['sites_id'].length; i++) {
            if (selected_site.value.id === dataSource['sites_id'][i].id) {
              value.value['sites_id'] = [dataSource['sites_id'][i]];
              attendance_edit['sites_id'] = [dataSource['sites_id'][i]];
              break;
            }
          }
        }
        if (selected_shift.value !== undefined) {
          for (let i = 0; i < dataSource['shifts_id'].length; i++) {
            if (selected_shift.value.id === dataSource['shifts_id'][i].id) {
              value.value['shifts_id'] = [dataSource['shifts_id'][i]];
              attendance_edit['shifts_id'] = [dataSource['shifts_id'][i]];
              break;
            }
          }
        }
      } else {
        if (selected_att_type.value !== undefined) {
          for (let i = 0; i < dataSource['att_type'].length; i++) {
            if (selected_att_type.value.id === dataSource['att_type'][i].id) {
              value.value['att_type'] = [dataSource['att_type'][i]];
              attendance_edit['att_type'] = [dataSource['att_type'][i]];
              break;
            }
          }
        }
        if (selected_designation.value !== undefined) {
          for (let i = 0; i < dataSource['designation'].length; i++) {
            if (selected_designation.value.id === dataSource['designation'][i].id) {
              value.value['designation'] = [dataSource['designation'][i]];
              attendance_edit['designation'] = [dataSource['designation'][i]];
              break;
            }
          }
        }
        if (selected_subsection.value != null && selected_subsection.value != 'Select Subsection') {
          for (let i = 0; i < dataSource['subsections'].length; i++) {
            if (selected_subsection.value.id === dataSource['subsections'][i].id) {
              value.value['subsections'] = [dataSource['subsections'][i]];
              attendance_edit['subsections'] = [dataSource['subsections'][i]];
              break;
            }
          }
        }
        if (selected_department.value != null) {
          for (let i = 0; i < dataSource['departments'].length; i++) {
            if (selected_department.value.id === dataSource['departments'][i].id) {
              saveDepartment(attendance_edit, i);
              break;
            }
          }
        }
        if (selected_site.value !== undefined) {
          for (let i = 0; i < dataSource['sites_id'].length; i++) {
            if (selected_site.value.id === dataSource['sites_id'][i].id) {
              value.value['sites_id'] = [dataSource['sites_id'][i]];
              attendance_edit['sites_id'] = [dataSource['sites_id'][i]];
              break;
            }
          }
        }
        if (selected_shift.value !== undefined) {
          for (let i = 0; i < dataSource['shifts_id'].length; i++) {
            if (selected_shift.value.id === dataSource['shifts_id'][i].id) {
              value.value['shifts_id'] = [dataSource['shifts_id'][i]];
              attendance_edit['shifts_id'] = [dataSource['shifts_id'][i]];
              break;
            }
          }
        }
      }
      if (Object.keys(value.value).length === 0) {
        return props.params.value
      }
      if (['Absent', 'Holiday'].includes(selected_att_type.value.name)) {
        workingHrs.value = '00:00'
        overtimeHrs.value = '00:00'
      }
      const workingMinutes = workingHrs.value;
      const overTimeMinutes = overtimeHrs.value;
      const note = sanitizeEditorNote(notes.value);
      const attendanceDate = props.params.column.colId;
      if (inTime.value === convertUtcToIst(value.value?.['in_time'])) {
        inTime.value = null;
      }
      if (outTime.value === convertUtcToIst(value.value?.['out_time'])) {
        outTime.value = null;
      }
      const inTimeValue = convertToUTCTimestamp(inTime.value, attendanceDate);
      const outTimeValue = convertToUTCTimestamp(outTime.value, attendanceDate);
      if (workingMinutes !== null) {
        value.value['working_minutes'] = timeStringToMinutes(workingMinutes !== null ? workingMinutes : '');
        attendance_edit['working_minutes'] = value.value['working_minutes'];
      }
      if (overTimeMinutes !== null) {
        value.value['overtime_minutes'] = timeStringToMinutes(overTimeMinutes !== null ? overTimeMinutes : '');
        attendance_edit['overtime_minutes'] = value.value['overtime_minutes'];
      }
      if (note !== null || value.value?.['exception'] !== null) {
        if (value.value.notes !== note && value.value?.['exception']?.[value.value['exception'].length - 1]?.['description'] !== note) {
          value.value['notes'] = note;
          attendance_edit['notes'] = note;
        }
      }
      if (inTimeValue !== null && inTimeValue !== undefined && inTimeValue !== '' && inTimeValue !== value.value['in_time']) {
        value.value['in_time'] = inTimeValue;
        attendance_edit['in_timestamp'] = value.value['in_time'];
      }
      if (outTimeValue !== null && outTimeValue !== undefined && outTimeValue !== '' && outTimeValue !== value.value['out_time']) {
        value.value['out_time'] = outTimeValue;
        attendance_edit['out_timestamp'] = value.value['out_time'];
      }

      if (Object.keys(attendance_edit).length === 0) {
        return props.params.value;
      }

      const keysToCheck = ['att_type', 'designation', 'sites_id', 'shifts_id'];

      const missingKeys = checkKeys(value.value, keysToCheck);
      const editsMissingKeys = checkKeys(attendance_edit, keysToCheck);
      value.value['editing'] = true;
      if (missingKeys.present === false) {
        value.value['attendance_edit'] = attendance_edit;
      } else {
        if (value.value['attendance_edit'] !== undefined) {
          delete value.value['attendance_edit'];
        }
        if (editsMissingKeys.present === false) {
          for (let i = 0; i < editsMissingKeys.missingKeys.length; i++) {
            attendance_edit[editsMissingKeys.missingKeys[i]] = value.value[editsMissingKeys.missingKeys[i]];
          }
        }

        const attendanceDate = getAttendanceDate(props.params, null);
        attendance_edit['attendance_date'] = attendanceDate;
        attendance_edit['sync_timestamp'] = attendanceDate;
        value.value['editing'] = false;
        attendance_edit['employees_id'] = props.params.data['employees'];
        props.params.isEditedEnable(true);
        //adding the att edit types docp as manual
        attendance_edit['attendance_edit_type'] = dataSource['attendance_edit_type'].filter((each) => each.code == 'manual');

        value.value['attendance_edit'] = attendance_edit;
      }
      //checking for refetched values
      for (const prop in props.params.value) {
        if (value.value['attendance_edit'].hasOwnProperty(prop)) {
          if (
            !props.params?.value?.hasOwnProperty?.('attendance_edit') &&
            prop != 'attendance_date' &&
            JSON.stringify(props.params.value[prop]) === JSON.stringify(value.value['attendance_edit'][prop])
          ) {
            value.value['attendance_edit'][prop] = null
          }
          else if (
            props.params?.value?.hasOwnProperty?.('attendance_edit') &&
            prop != 'attendance_date'  && props.params.value.attendance_edit[prop] == null &&
            JSON.stringify(props.params.value[prop]) === JSON.stringify(value.value['attendance_edit'][prop])
          ) {
            value.value['attendance_edit'][prop] = null
          }
        }
      }
      return value.value;
    }

    const isCancelBeforeStart = () => {
      return false;
    };

    const isCancelAfterEnd = () => {
      return false;
    };

    onMounted(async() => {
      docpOptions.value.att_type = dataSource.att_type.map(
        (item) => ({ name: item['name']['eng'], id: item.id }
        ));
      docpOptions.value.designation = dataSource.designation.map(
        (item) => ({ name: item['name'], id: item.id }
        ));
      docpOptions.value.departments = dataSource.departments.map(
        (item) => ({ name: item['name'], id: item.id }
        ));
      docpOptions.value.sites_id = dataSource.sites_id.map(
        (item) => ({ name: item['name']['eng'], id: item.id }
        ));
      docpOptions.value.shifts_id = dataSource.shifts_id.map(
        (item) => ({ name: item['name'], id: item.id }
        ));
      workingHrs.value = value.value !== undefined ? convertMinutesToHoursFormat(value.value?.['working_minutes']) : null;
      overtimeHrs.value = value.value !== undefined ? convertMinutesToHoursFormat(value.value?.['overtime_minutes']) : null;
      inTime.value = value.value !== undefined ? convertUtcToIst(value.value?.['in_time']) : null;
      outTime.value = value.value !== undefined ? convertUtcToIst(value.value?.['out_time']) : null;
      const getLatestMeaningfulExceptionNote = (exceptionList) => {
        if (!Array.isArray(exceptionList) || exceptionList.length === 0) {
          return null;
        }
        for (let i = exceptionList.length - 1; i >= 0; i--) {
          const noteText = sanitizeEditorNote(exceptionList[i]?.description);
          if (noteText != null) {
            return noteText;
          }
        }
        return null;
      };
      const localDraftNote = sanitizeEditorNote(value.value?.attendance_edit?.notes ?? value.value?.notes);
      const currentCellExceptionNote = getLatestMeaningfulExceptionNote(value.value?.exception);
      const attendanceDataExceptionNote = getLatestMeaningfulExceptionNote(value.value?.attendanceData?.exception);
      const currentCellRemarksNote = sanitizeEditorNote(value.value?.remarks);
      const attendanceDataRemarksNote = sanitizeEditorNote(value.value?.attendanceData?.remarks);
      const initialNote = localDraftNote
        ?? currentCellExceptionNote
        ?? attendanceDataExceptionNote
        ?? currentCellRemarksNote
        ?? attendanceDataRemarksNote;
      initialPrefilledNote.value = initialNote;
      notes.value = initialNote;
      validateMandatoryNotes();
      nextTick(() => {
        if (inputText1.value) {
          inputText1.value.$el.querySelector('input').focus();
        }
        isInitializingEditor.value = false;
      })
    });

    function keyboardCommandsHandler(event) {
      if (event && event.key === 'Enter' && event.ctrlKey === true) {
        event.preventDefault();
        event.stopPropagation();
        if (!canSaveEditor()) {
          return;
        }
        props.params.stopEditing();
      }
      // event.stopPropagation();
    }

    const focusNext = async(e, currentIndex) => {
      const refList = [
        inputText1, inputText2, inputText3, inputText4, inputText5, inputText6,
        input1
      ];

      if ((e && e.key === 'Tab') || (e.key === 'Enter' && e.ctrlKey !== true)) {
        e.preventDefault(); // Prevent the default Tab behavior
        if (isHovered !== null) {
          if (isHovered?.name === selected_att_type.value?.name) {
            selected_att_type.value = null;
            isHovered = null;
          } else if (isHovered?.name === selected_designation.value?.name) {
            selected_designation.value = null; // Assuming you want to reset this too
            isHovered = null;
          } else if (isHovered?.name === selected_shift.value?.name) {
            selected_shift.value = null; // Assuming you want to reset this too
            isHovered = null;
          } else if (isHovered?.name === selected_site.value?.name) {
            selected_site.value = null; // Assuming you want to reset this too
            isHovered = null;
          }
        }
        // Determine the direction: forward or backward
        const isShiftPressed = e.shiftKey;
        const nextIndex = isShiftPressed
          ? (currentIndex - 1 + refList.length) % refList.length  // move to the previous element
          : (currentIndex + 1) % refList.length;  // move to the next element

        const nextElement = refList[nextIndex].value;

        await nextTick(); // Ensure the next DOM update is completed

        if (nextElement && nextElement.$el) {
          const inputEl = nextElement.$el.querySelector('input');
          if (inputEl) {
            inputEl.focus();
          } else {
            nextElement.focus(); // for non-input elements
          }
        } else if (nextElement) {
          nextElement.focus(); // for input elements directly
        }
      }

      // Stop editing when Enter is pressed without Shift and on the last element
      if (e && e.key === 'Enter' && e.ctrlKey === true) {
        if (!canSaveEditor()) {
          return;
        }
        props.params.stopEditing();
      }
    };

    const createKeydownHandler = (currentIndex) => {
      return (map, vm) => ({
        ...map,
        9: async(e) => { // Tab key
          e.preventDefault();
          e.stopPropagation();
          await focusNext(e, currentIndex);
        },
        13: async(e) => { // Enter key
          e.stopPropagation();
          vm.typeAheadSelect(); // Ensure selection
          await nextTick();
          await focusNext(e, currentIndex);
        }
      });
    };

    const handleKeydown = async(currentIndex, e) => {
      if (e.key === 'Tab') {
        e.preventDefault();
        e.stopPropagation();
        await focusNext(e, currentIndex);
      } else if (e.key === 'Enter') {
        e.stopPropagation();
        // vm.typeAheadSelect(); // Ensure selection
        await nextTick();
        await focusNext(e, currentIndex);
      }
    };

    function convertUtcToIst(utcTime) {
      if (!utcTime || isNaN(new Date(utcTime).getTime())) {
        return '';
      }
      const utcDate = new Date(utcTime);
      const ISTOffset = 330;
      const localOffset = utcDate.getTimezoneOffset();
      const offsetDifference = ISTOffset - localOffset;
      const istDate = new Date(utcDate.getTime() + offsetDifference);


      // Format as HH:MM:SS
      const hours = String(istDate.getHours()).padStart(2, '0');
      const minutes = String(istDate.getMinutes()).padStart(2, '0');
      const seconds = String(istDate.getSeconds()).padStart(2, '0');

      return `${hours}:${minutes}:${seconds}`;
    }

    function checkKeys(object, keys) {
      const missingKeys = [];
      for (const key of keys) {
        if (!object.hasOwnProperty(key)) {
          missingKeys.push(key);
        }
      }
      if (missingKeys.length === 0) {
        return { present: true };
      } else {
        return { present: false, missingKeys };
      }
    }

    function convertToUTCTimestamp(timeString, dateString) {
    // Handle special cases: "0:0:0", null, or empty string
      if (timeString === '0:0:0' || timeString === null || timeString === '') {
        return null;
      }

      // Parse the time string "HH:MM:SS"
      const [hours, minutes, seconds] = timeString.split(':').map(Number);

      // Parse the date string "1Sep2024"
      const dateParts = dateString.match(/(\d{1,2})([a-zA-Z]{3})(\d{4})/);
      if (!dateParts) {
        throw new Error('Invalid date format');
      }

      const day = parseInt(dateParts[1], 10);
      const month = new Date(Date.parse(dateParts[2] + ' 1, 2024')).getMonth(); // Get the month index (0-11)
      const year = parseInt(dateParts[3], 10);

      // Create a Date object in IST using the parsed date and time
      const istDate = new Date(Date.UTC(year, month, day, hours, minutes, seconds));

      // Subtract 5 hours and 30 minutes from IST to get UTC
      const timeZoneOffset = istDate.getTimezoneOffset();
      if (timeZoneOffset > 0) {
        istDate.setUTCMinutes(istDate.getUTCMinutes() - timeZoneOffset);
      } else {
        istDate.setUTCMinutes(istDate.getUTCMinutes() - (-timeZoneOffset));
      }
      // 5 hours and 30 minutes is 330 minutes

      // Return the UTC timestamp in ISO format
      return istDate.toISOString();
    }

    function onClose(event) {
      console.log(event)
    }

    const formattedTime = computed(() => {
      if (workingHrs.value && !error.value) {
        const [hours, minutes] = workingHrs.value.split(':');
        return `${hours} hours and ${minutes} minutes`;
      }
      return '';
    });

    // Function to automatically format the input to HH:MM
    const formatTime = (event) => {
      let input = event.target.value.replace(/[^0-9]/g, ''); // Only keep numbers
      if (input.length > 2) {
        input = input.slice(0, 2) + ':' + input.slice(2); // Insert ':' after two digits
      }
      workingHrs.value = input; // Update the v-model with the formatted value

      // Validate time format (HH:MM in 24-hour format)
      const timePattern = /^([01]\d|2[0-3]):([0-5]\d)$/;
      if (!timePattern.test(workingHrs.value)) {
        error.value = 'Please enter a valid time (HH:MM).';
      } else {
        error.value = ''; // Clear error if valid
      }
    };

    function handleWorkingHoursInput(event) {
      formatTime(event);
      onEditFieldChange('working_minutes', workingHrs.value);
    }

    function handleOvertimeHoursInput(event) {
      const overtimeValue = event?.target?.value ?? overtimeHrs.value;
      onEditFieldChange('overtime_minutes', overtimeValue);
    }

    function setHovered(value) {
      if (value && value.name !== '') {
        isHovered = JSON.parse(JSON.stringify(value));
      } else {
        console.warn('Hovered value is invalid:', value);
      }
    }
    watch(notes, () => {
      validateMandatoryNotes();
    });

    return {
      setHovered,

      keyboardCommandsHandler,
      onClose,
      isReadOnly,
      default_leave_type,

      inputText1,
      inputText2,
      inputText3,
      inputText4,
      inputText5,
      inputText6,
      input1,
      input2,
      input3,
      input4,
      input5,
      createKeydownHandler,
      handleKeydown,
      onEditFieldChange,
      onNotesInput,
      onDepartmentChange,

      isPopup,
      getValue,
      isCancelAfterEnd,
      isCancelBeforeStart,

      docpOptions,
      workingHrs,
      error,
      formattedTime,
      formatTime,
      handleWorkingHoursInput,
      handleOvertimeHoursInput,
      overtimeHrs,
      inTime,
      outTime,
      notes,
      noteValidationError,
      isNotesMandatoryForCurrentEdit,
      selected_att_type,
      default_att_type,
      selected_designation,
      default_designation,
      selected_department,
      default_department,
      selected_subsection,
      default_subsection,
      selected_site,
      default_site,
      selected_shift,
      default_shift,
      subsOptions
    };
  }
}
</script>

<style>
.editor_container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 450px;
  height: 650px;
  background-color: white;
}

.editor_header {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 8%;
  background-color: gray;
}

.editor_fields {
  width: 100%;
  height: 80%;
  display: flex;
  align-items: center;
}

.editor_form {
  padding: 10px;
  width: 100%;
}

.editor_field {
  display: flex;
  justify-content: space-between;
  padding: 0 3%;
  align-items: center;
  margin: 4%;
}

.form_label {
  width: 30% !important;
  float: left;
  text-align: left;
}

.form_docpicker {
  width: 60% !important;
}

.editor_field p {
  margin: 0;
  margin-top: 1px;
  font-size: 10px;
}


.vs__selected-options {
  flex-wrap: nowrap;
  overflow: hidden;
  white-space: nowrap;
}

.editor_bottom {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 8%;
  background-color: gray;
}

</style>
